import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('meiosocioeconomicos');

export const check = () => useBasicAuth.checkToken();

export const findMeioSocioEconomicoById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllMeioSocioEconomico = () => 
  axios.get(urlAPI + "/findAll" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllMeioSocioEconomicoByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllMeioSocioEconomicoByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const addMeioSocioEconomico = (obj) => 
  axios.post(urlAPI + "/addMeioSocioEconomico", JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateMeioSocioEconomico = (obj) => 
  axios.put(urlAPI + "/updateMeioSocioEconomico/" + obj.meioSocioEconomico.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteMeioSocioEconomico = (id) => 
  axios.delete(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



  //CLIMA_CIDADE
export const findAllByMeioSocioEconomicoCidade_meioSocioEconomico = (meioSocioEconomico) => 
axios.post(urlAPI + "/meioSocioEconomicocidade/meioSocioEconomico", JSON.stringify(meioSocioEconomico), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByMeioSocioEconomicoCidade_cidade = (cidade) => 
axios.post(urlAPI + "/meioSocioEconomicocidade/cidade", JSON.stringify(cidade), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByMeioSocioEconomicoCidade = (meioSocioEconomico, cidade) => {
let requestObj = {
  meioSocioEconomico: meioSocioEconomico,
  cidade: cidade
}
axios.post(urlAPI + "/meioSocioEconomicocidade", JSON.stringify(requestObj), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});
}


//CLIMA_ESTADO
export const findAllByMeioSocioEconomicoEstado_meioSocioEconomico = (meioSocioEconomico) => 
axios.post(urlAPI + "/meioSocioEconomicoestado/meioSocioEconomico", JSON.stringify(meioSocioEconomico), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByMeioSocioEconomicoEstado_estado = (estado) => 
axios.post(urlAPI + "/meioSocioEconomicoestado/estado", JSON.stringify(estado), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByMeioSocioEconomicoEstado = (meioSocioEconomico, estado) => {
let requestObj = {
  meioSocioEconomico: meioSocioEconomico,
  estado: estado
}
axios.post(urlAPI + "/meioSocioEconomicoestado", JSON.stringify(requestObj), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});
}